var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(1 0 0 -1 0 20)",
    fill: "#234492"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1307 7.25439C10.2462 7.34151 10.3742 7.41441 10.4756 7.51576C11.7327 8.76572 12.9844 10.021 14.2379 11.2727C14.3606 11.3954 14.4513 11.527 14.4442 11.7101C14.437 11.9199 14.3375 12.0711 14.1561 12.1635C13.973 12.256 13.7898 12.2382 13.6209 12.1173C13.564 12.0764 13.516 12.0248 13.4662 11.9751C12.3568 10.8673 11.249 9.75964 10.1413 8.65014C10.0987 8.60747 10.0649 8.55946 10.0169 8.49901C9.95463 8.55946 9.9084 8.60036 9.86395 8.64481C8.73668 9.77386 7.60941 10.9011 6.48213 12.0284C6.1692 12.3396 5.71047 12.2507 5.58423 11.8542C5.52022 11.6568 5.56467 11.479 5.70869 11.3314C5.88472 11.1483 6.06608 10.9705 6.24566 10.7909C7.33559 9.70096 8.42197 8.61103 9.51546 7.52465C9.62036 7.41974 9.75194 7.34329 9.87106 7.25261H10.1307V7.25439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8);
export default __webpack_public_path__ + "static/media/Group 8.fea5c29d32492164b148086abedbd5ca.svg";
export { ForwardRef as ReactComponent };